import { useNavigate } from '@tanstack/react-router';
import { CompanyFinance } from '../modules/finance/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { FinanceView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyFinanceScreen({
  view,
  onView,
}: {
  view: FinanceView;
  onView: ViewSetter<FinanceView>;
}) {
  const { can, today, company, timeZone } = useCompanyScope();
  const navigate = useNavigate();
  const units = company.businessUnits ?? [];
  const consolidated = units.length > 1 && (company.activeBusinessUnitId ?? null) === null;
  /// Na visão consolidada o Financeiro só consulta: gravar sempre acontece numa unidade (ADR 0039).
  const may = (permission: string) => !consolidated && can(permission);
  return (
    <GatedCompanyScreen allowed={can('financial_movements.read')}>
      <CompanyFinance
        capabilities={{
          canSettle: may('financial_reconciliation.settle'),
          canManageRules: may('financial_reconciliation.rules'),
          canCreateMovement: may('financial_movements.create'),
          canUpdateMovement: may('financial_movements.update'),
          canCancelMovement: may('financial_movements.cancel'),
          canCreateAccount: may('financial_accounts.create'),
          canUpdateAccount: may('financial_accounts.update'),
          canArchiveAccount: may('financial_accounts.archive'),
          canClose: may('financial_closing.close'),
          canReopen: may('financial_closing.reopen'),
        }}
        consolidated={consolidated}
        timeZone={timeZone}
        today={today}
        view={view}
        onView={onView}
        onOpenObligations={(direction) => {
          void navigate({
            to:
              direction === 'PAYABLE'
                ? '/companies/$companyKey/payables'
                : '/companies/$companyKey/receivables',
            params: { companyKey: company.key },
          });
        }}
      />
    </GatedCompanyScreen>
  );
}
